import React, { useContext } from 'react';

import { CardListSkeleton } from '@eika-kortbetjening/card-list-panel';
import { ErrorCard } from '@eika/card';
import { LinkList } from '@eika/link-list';

import CardControlContext from '@/context/card-control/CardControlContext';
import { useUserUnder13 } from '@/domain/session';
import useCardRules from '@/react-query/hooks/query/use-card-rules';
import { useCardSpendingLimits } from '@/react-query/hooks/query/use-spending-limits';

import useText from '@hooks/use-text';

import { SpendingLimitCategory } from '../types';
import { Setting } from './Setting';
import { SpendingLimitCategoryLink } from './SpendingLimitCategoryLink';
import { SettingInfo } from './modals/InfoModal';

export const SpendingLimitsEcommerceSettings = () => {
    const { data: cardRules } = useCardRules();
    const text = useText();
    const {
        data: spendingLimits,
        isLoading: isLoadingSpendingLimits,
        isError: spendingLimitsError,
    } = useCardSpendingLimits();
    const { selectCategory, selectInfoModal } = useContext(CardControlContext);
    const isUnder13 = useUserUnder13();
    if (isUnder13) {
        return null;
    }

    if (cardRules && !cardRules.ecommerce) {
        return null;
    }

    if (spendingLimitsError) {
        return <ErrorCard title={text.spendingLimitFetchError} />;
    }

    if (isLoadingSpendingLimits || typeof spendingLimits === 'undefined') {
        return <CardListSkeleton panelCount={2} />;
    }

    return (
        <Setting
            title={text.spendingLimitsNetLabel}
            onInfoClick={() => selectInfoModal(SettingInfo.SpendingLimitsEcommerce)}
        >
            <LinkList>
                <SpendingLimitCategoryLink
                    description={text.spendingLimitsLabelDaily}
                    limit={spendingLimits.app?.daily}
                    onClick={() => selectCategory(SpendingLimitCategory.DailyLimitEcommerce)}
                />
                <SpendingLimitCategoryLink
                    description={text.spendingLimitsLabelMonthly}
                    limit={spendingLimits.app?.monthly}
                    onClick={() => selectCategory(SpendingLimitCategory.MonthlyLimitEcommerce)}
                />
            </LinkList>
        </Setting>
    );
};
